/**
 * Výška notifikační položky.
 */
export const NOTIFICATION_ITEM_HEIGHT = 56;
